import { render, staticRenderFns } from "./NsHeaderRegionSelector.vue?vue&type=template&id=2171e6ba&scoped=true&"
import script from "./NsHeaderRegionSelector.vue?vue&type=script&lang=js&"
export * from "./NsHeaderRegionSelector.vue?vue&type=script&lang=js&"
import style0 from "./NsHeaderRegionSelector.vue?vue&type=style&index=0&id=2171e6ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../packages/aem/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2171e6ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/webcomponents-ui - release-finish/src/main/content/webcomponents/js/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2171e6ba')) {
      api.createRecord('2171e6ba', component.options)
    } else {
      api.reload('2171e6ba', component.options)
    }
    module.hot.accept("./NsHeaderRegionSelector.vue?vue&type=template&id=2171e6ba&scoped=true&", function () {
      api.rerender('2171e6ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@nuskin/app-components/components/NsHeaderRegionSelector.vue"
export default component.exports